<template>
  <div class="main">
    <van-nav-bar title="审批系统" />
    <img src="~assets/image/error.png" class="errorImg" alt="">
    <p class="error-tips">提现失败</p>
    <p class="error-text">账户异常请您更换其他账户完成放款</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.errorImg {
  display: block;
  margin: 0 auto;
  width: 70px;
  margin-top: 50px;
}
.error-tips {
  font-size: 18px;
  text-align: center;
  margin: 25px 0px;
}
.error-text {
  width: 100%;
  height: 38px;
  background: #fff;
  line-height: 38px;
  text-align: center;
  font-size: 14px;
}
</style>
